module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    attrs: {
      "text": "",
      "elevation": "0"
    }
  }, [_c('v-card-text', [_c('v-layout', [_c('v-flex', {
    staticClass: "text-xs-center"
  }, [_c('v-progress-circular', {
    attrs: {
      "rotate": -90,
      "size": 100,
      "width": 20,
      "value": Math.round(_vm.usage * 100),
      "color": _vm.color
    }
  }, [_c('div', {
    staticClass: "text-xs-center"
  }, [_vm._v("\n            " + _vm._s(Math.round(_vm.usage * 100)) + " % Used\n          ")])])], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', {
    staticClass: "subtitle-2"
  }, [_vm._v("\n    " + _vm._s(_vm.name) + ":\n    "), _c('v-spacer'), _vm._v("\n    " + _vm._s(_vm.used) + " / " + _vm._s(_vm.available) + "\n  ")], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ea9cf352"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Campaign/UsageCircularBox.vue
// module id = 2308
// module chunks = 0